import React from 'react';
import './InsufficientRequest.css';
import close from '../Images/icon.png'
import { useNavigate } from 'react-router-dom';


const InsufficientRequests = ({setInsufficientOpen}) => {
  const navigate=useNavigate()
  return (
    <div className="insuff-container">
      <div className="insuff-header">
        <h2>Insufficient Requests To Send</h2>

       
        <div onClick={()=>setInsufficientOpen(false)}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#838383"/>
</svg>
</div>
      </div>
      <div className='insuff-line'></div>
      <div className="insuff-section">
        <div className="insuff-warning">
          <div className="insuff-icon">
            <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 16C12 16.5523 11.5523 17 11 17C10.4477 17 10 16.5523 10 16C10 15.4477 10.4477 15 11 15C11.5523 15 12 15.4477 12 16Z" fill="#1A0DAB"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0C11.3632 0 11.6978 0.196892 11.8742 0.514357L21.8742 18.5144C22.0462 18.8241 22.0416 19.2017 21.8619 19.5071C21.6822 19.8125 21.3543 20 21 20H1C0.64568 20 0.317815 19.8125 0.138129 19.5071C-0.0415561 19.2017 -0.0462301 18.8241 0.125843 18.5144L10.1258 0.514357C10.3022 0.196892 10.6368 0 11 0ZM2.69951 18H19.3005L11 3.05913L2.69951 18ZM11 7C11.5523 7 12 7.44772 12 8V12C12 12.5523 11.5523 13 11 13C10.4477 13 10 12.5523 10 12V8C10 7.44772 10.4477 7 11 7Z" fill="#1A0DAB"/>
            </svg>
          </div>
          <div className='insuff-sub-container'>
          <p className="insuff-message">
            You don't have enough requests available to complete this action
          </p>
          <p className="insuff-balance">Current Balance: 0 Requests</p>
          </div>
        </div>
        <div className='insuff-line'></div>
        <div className="insuff-option" >
          <div className='insuff-icon-msg'>
          <div className="insuff-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"  href="http://www.w3.org/1999/xlink">
<rect width="20" height="20" fill="url(#pattern0_4156_32657)"/>
<defs>
<pattern id="pattern0_4156_32657" patternContentUnits="objectBoundingBox" width="1" height="1">
<use href="#image0_4156_32657" transform="scale(0.015625)"/>
</pattern>
<image id="image0_4156_32657" width="64" height="64" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAATNJREFUeJzt2r0uBGEYhuH7HSMh4icbso1SrdFxDGrtxomoHIVjkD0J0VMqdETWEhlWNOZV+PycgHkS81zNZL7qnqea4gMzMzMz66f4/TIgV+Zgu4IFVdBfauHtHS4fiebr7HuAIXmQwQmwLKnrTkNyOCFOoQwwIDfr4ApYlKZ1Z5bJ1j1xVwHMwx79+XiApYBdgKocrApjJBLW4GeA3vIA6gC13g9Ql2cDXCtDBJ7VAWZmZmIBMCT3CY7UMV3K5HhCjGuAFtYDdtRRXQrYAP8KewAPoA5Q8wDqADUPoA5Q8wDqADUPoA5Q8wDqADUPoA5Q8wDqADUPoA5Q8wDl+SKtEGjhCcoALZwDr9Kibs0SzqAM8EDcZDLi86LEf9dkMpoSt9DDq7IJF1PCt0PMzMzMeu8D2MI6sIsE95cAAAAASUVORK5CYII="/>
</defs>
</svg>

          </div>
          <p className="insuff-option-head">
            <strong >Buy More Requests</strong>
          </p>
          </div>
          <div className='insuff-sub-container1'>
         
          <p className="insuff-message">
            Contact us on Telegram to quickly add more requests.
          </p>
          <a onClick={()=>window.open("https://t.me/salesraisa","_blank")} className="insuff-link" style={{cursor:"pointer"}}>
            Buy More Requests
          </a>
          </div>
        </div>
        <div className='insuff-line'></div>
        <div className="insuff-option free">
          <div className='insuff-icon-msg'>
          <div className="insuff-icon">

          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" href="http://www.w3.org/1999/xlink">
<rect width="20" height="20" fill="url(#pattern0_4156_32654)"/>
<defs>
<pattern id="pattern0_4156_32654" patternContentUnits="objectBoundingBox" width="1" height="1">
<use href="#image0_4156_32654" transform="scale(0.015625)"/>
</pattern>
<image id="image0_4156_32654" width="64" height="64" href="data:image/png;base64,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"/>
</defs>
</svg>

          </div>
          <p className="insuff-option-head">
            <strong>Wait for Free Requests</strong>
          </p>
          </div>
          <div className='insuff-sub-container1'>
         
          <p className="insuff-message">
            Your free monthly requests will renew at the end of the month.
          </p>
          <a href="#wait-for-free" className="insuff-link free">
            Wait for Free Requests
          </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsufficientRequests;
